import React from 'react';
import MUITextField, {
  TextFieldProps as MUITextFieldProps,
} from '@mui/material/TextField';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  filledInput: {
    backgroundColor: theme.palette.grey[50],
    '&:hover': {
      backgroundColor: theme.palette.grey[50],
    },
    '&:focus': {
      backgroundColor: theme.palette.grey[50],
    },
    '&:active': {
      backgroundColor: theme.palette.grey[50],
    },
    '&:visited': {
      backgroundColor: theme.palette.grey[50],
    },
    '&:focus-within': {
      backgroundColor: theme.palette.grey[50],
    },
  },
}));

const TextField: React.FC<MUITextFieldProps> = ({
  variant,
  InputProps = {},
  ...rest
}) => {
  const { classes, cx } = useStyles();

  return (
    <MUITextField
      variant={variant}
      InputProps={{
        ...InputProps,
        classes: {
          ...InputProps.classes,
          root: cx(
            {
              [classes.filledInput]: variant === 'filled',
            },
            InputProps.classes?.root,
          ),
        },
      }}
      {...rest}
    />
  );
};

export { TextField };

export type TextFieldProps = MUITextFieldProps;
